module.exports = __webpack_public_path__ + "img/40_69_000_410.28518a71.jpg";